import { publicApiCall, httpCall } from '../common/util';
import { MiddlePanelConstant } from '../containers/WorkkardDetail/constants';

const getactivityActionUrl=(payload)=>
{
    let url="";
    switch(payload.actionType){
        case MiddlePanelConstant.CompleteText:
         return url= `/1.0/activity/complete/${payload.ActivityId}`;
         case MiddlePanelConstant.RejectText:
          return url= `/1.0/activity/reject/${payload.ActivityId}`;
         case MiddlePanelConstant.AcceptText:
            return url= `/1.0/activity/accept/${payload.ActivityId}`;
         case MiddlePanelConstant.ReOpenText:
         return url= `/1.0/activity/reopen/${payload.ActivityId}`;
         case MiddlePanelConstant.CloseText:
          return url= `/1.0/activity/close/${payload.ActivityId}`;
        default:
        break;
    }
}

export const changeActivityOwner = async(payload)=>{
    var options = {
        method: 'PUT',
        url: `/1.0/activity/change_owner/${payload.activity_id}`,
        data:{owner_id:payload.sponser_id} 
    };
    return httpCall(options);
}

export const changeActivityAssignee = async(payload)=>{
    let activityId=payload.activityId;
    delete payload.activityId;
    delete payload.workkardId;
    var options = {
        method: 'PUT',
        url: `/1.0/activity/change_assignee/${activityId}`,
        data:payload
    };
    return httpCall(options);

}

export const changeActivityResolution =async(id, payload)=>{
    var options = {
        method: 'PUT',
        url: `/1.0/activity/inprogress/${id}`,
        data:payload
    };
    return httpCall(options);

}

export const actionsForActivities =async(payload)=>{
    let data = "";
    if (payload.wrr) {
        data = {reopen_reason: payload.wrr, reopen_sub_reason: payload.wrSubReason};
    } else if (payload.rejectReason) {
        data = {reject_reason: payload.rejectReason};
    }
    var options = {
        method: 'PUT',
        url:  getactivityActionUrl(payload),
        data
    };
    return httpCall(options, true);

}
